import { createSelector } from 'reselect'
import { emptyArr, sortByName } from 'util/arrays'

export const selectGroups = state => state.groups || emptyArr

export const selectGroupsById = createSelector(selectGroups, groups => {
  return groups.reduce((groupsById, group) => {
    // eslint-disable-next-line no-param-reassign
    groupsById[group.id] = group
    return groupsById
  }, {})
})

export const selectGroupsSortedByName = createSelector(
  selectGroupsById,
  groupsById => {
    return sortByName(Object.values(groupsById))
  }
)
